import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import "../../Styles/CurrencyConfiguration.scss";
import Currency from "./Currency.json";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import Api from "../../Services/Api";
import { CircularProgress } from "@material-ui/core";

export default class CurrencyConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      loader: false,
      updatedAndSortedCurrencies:[]
    };
  }
  componentDidMount() {
    this.isAuthorizeUse();
  }
  isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (this.props.match.params.id) {
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`,
        });
      } else {
        this.props.history.push({
          pathname: "/",
        });
      }
    } else {
      this.createMasterCurrencyList();
      this.GetCurrency();
    }
  };
  createMasterCurrencyList=()=>{
    const updatedAndSortedCurrencies = Currency
    .map(currency => ({
      ...currency,
      displayName: `${currency.name} - ${currency.code}`
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
    this.setState({ updatedAndSortedCurrencies: updatedAndSortedCurrencies });

  }
  handleSubmit = async () => {
    this.setState({ loader: true });
    const requestParams = {
      Currency: JSON.stringify(this.state.value),
      CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      CreatedDate: new Date(),
    };
    let response = await Api.AddCurrency(requestParams);
    if (response.status === 200) {
      this.setState({ loader: false });
      secureLocalStorage.setItem("currency",this.state.value.symbol);
      toastr.success(response.message);
    } else {
      this.setState({ loader: false });
      toastr.error(response.message);
    }
  };
  GetCurrency = async () => {
    try {
      let response = await Api.GetCurrency();
      if (response.status === 200) {
        if(response.currencyTypes&&response.currencyTypes.length>0&&response.currencyTypes[0].currency){
          let curr=JSON.parse(response.currencyTypes[0].currency);
          this.setState({ value: curr });
        }
      }
    } catch (err) {
      console.error("Exception:", err);
    }
  };
  render() {
    return (
      <div className="form">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <form >
          <label className="field1">Select Currency</label>
          <div className="field2">
            <DropDownList
              data={this.state.updatedAndSortedCurrencies}
              value={this.state.value}
              onChange={(e) => {
                this.setState({
                  ...this.state,
                  value: e.target.value,
                });
              }}
              textField="displayName"
            />
          </div>
          {/* <span>{value.symbol}</span> */}
          <button disabled={!this.state.value} className="rm-btn-primary" onClick={() => this.handleSubmit()} type="button">
            Submit
          </button>
        </form>
      </div>
    );
  }
}
